import type { Tone } from '../../components/tone';
import type { NotifGroup } from './build';

/** The three sections of the notification centre */
export const GROUPS: { group: NotifGroup; title: string; subtitle: string; tone: Tone; icon: string }[] = [
  {
    group: 'Needs Attention',
    title: 'Needs Your Attention',
    subtitle: 'These items require your decision or action.',
    tone: 'error',
    icon: '!',
  },
  {
    group: 'Updates',
    title: 'Important Updates',
    subtitle: 'Key shipment and operational updates for your information.',
    tone: 'info',
    icon: 'i',
  },
  {
    group: 'Reminders',
    title: 'Reminders',
    subtitle: 'Upcoming and overdue tasks that need your follow-up.',
    tone: 'success',
    icon: '⏰',
  },
];
